<template>
  <div class="orderList" v-if="searchRecordList.length>0">
    <div
      class="search-records fine-scroll-bar"
      v-infinite-scroll="loadSearchRecords"
      :infinite-scroll-distance="1"
      :infinite-scroll-disabled="isFinalPage"
    >
      <div
        v-for="(item, index) in searchRecordList"
        :key="item.id"
        class="listDiv"
        @click="activeItem(item, index)"
      >
        <div class="itemCard" :class="active == index ? 'activeCard' : ''">
          <!-- <div class="isEmergencytag" v-if="item.isEmergency == 1">
            <i class="iconfont icon-urgency"></i> 紧急
          </div> -->
          <div class="channel-data-tag">
            <span class="channel-title">{{item.clientStr}}</span>
          </div>
          <div class="iteminfo">
            <div class="iteminfoLeft">
              <div class="infoTitle">
                <div class="name" :class="active != index&&item.isRead==1 ?'isRead':''">{{ item.title }}</div>
                <el-popover
                  v-if="item.isCarbonFootprint"
                  width="424px"
                  popper-class="carbon-tip"
                  class="box-item"
                  placement="bottom-start"
                  :tabindex="1"
                  trigger="hover"
                >
                  <div>含碳足迹报告需求。供应商报价中将包含为您定制的碳足迹报告。</div>
                  <div>如无法提供该询盘相关碳足迹报告，供应商会第一时间联系采购</div>
                  <template #reference>
                    <img
                      class="carbon-img"
                      src="@/assets/image/common/carbon.png"
                      alt=""
                      @click.stop
                    />
                  </template>
                </el-popover>
                <i class="iconfont" v-if="item.isCarbonFootprint"></i>
              </div>
              <div class="partNum"  :class="active != index&&item.isRead==1 ?'isRead':''">
                <div>
                  <span v-if="item.mainCategoryStr"
                    >{{ item.mainCategoryStr }} |
                  </span>
                  <span>采购量：{{ purchaseVolumeNum(item) }}</span>
                </div>
              </div>
              <div class="infoTag">
                <el-tag type="danger" class="tagItem" style="color: #FF081F; font-weight:700;background:rgba(255, 8, 31, 0.1)" v-if="item.isEmergency == 1">
                  <p style="display: flex;align-items:center"><i class="iconfont icon-urgency"></i> <span style="color: #FF081F; font-weight:700">紧急</span></p>
                </el-tag>
                <el-tag type="info" class="tagItem">{{ paymentTerms(item) }}</el-tag>
                <el-tag type="info" class="tagItem" v-if="item.ndaType!=0">{{
                  item.ndaTypeStr
                }}</el-tag>
                <!-- <el-tag type="info" class="tagItem">{{
                  item.clientStr
                }}</el-tag> -->
              </div>
            </div>
            <div class="iteminImg">
              <img
                :src="`${partDrawingUrl}${item.partThumbnailsHashCode}`"
                alt=""
                class="partLogo"
                :onerror="`this.src='${defaultRfqThn}'`"
              />
            </div>
          </div>
          <div class="itemComp">
            <div class="buyerCompName">{{ item.buyerCompName }}</div>
            <span class="addres" v-if="item.stateId == 247"
              ><i class="iconfont icon-icon-dingweidizhi"></i
              >{{ item.cityIdStr || '中国'}}</span
            >
            <span class="addres" v-else
              ><img :src="item.flagPath" alt="" class="flag"
            /></span>
          </div>
        </div>
      </div>
      <div
        v-if="searchRecordsLoading"
        class="records-page-loading"
        v-loading="true"
      ></div>
      <div
        v-if="isFinalPage && searchRecordList.length >= 10"
        class="records-page-loading"
      >
        到底了~
      </div>
    </div>
  </div>
</template>
<script>
import zhenyunOrderMinxis from "@/mixins/zhenyunOrder.js";
import { partnerRfqQuery } from "@/utils/api/zhenyunOrder";
import { companyLogoUrl,partDrawingUrl } from "@/utils/config";
export default {
  mixins: [zhenyunOrderMinxis],
  data() {
    return {
      partDrawingUrl,
      companyLogoUrl: companyLogoUrl,
      searchRecordsLoading: false, //搜索时的loading
      searchRecordList: [], //搜索记录
      finalId: null,
      isFinalPage: false, //是否最后一页，禁用滚动加载
      currentPage: 1,
      totalPage: 0,
      active: 0,
      defaultRfqThn:
        "https://res.haizol.com/base/images/default_rfq_thumb_56_56.png",
      rfqId:'',
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler: "nuxtRoutePath",
    },
  },
  methods: {
    // 付款方式
    paymentTerms(item){
      // item.paymentTermsStr
      if(item.paymentTerms==8&&item.paymentOwn){
        return '自定义付款条款'
      }else{
        return item.paymentTermsStr
      }
    },
    // 采购量
    purchaseVolumeNum(item){
      if(item.partsNum==1){
        return item.purchaseVolume||'--'
      }else{
        return item.partsNum+'种零件'
      }
    },
    async nuxtRoutePath() {
      // 路由变化时
      try {
        this.rfqId=''
        this.currentPage = 1;
        this.isFinalPage = false;
        this.searchRecordList = [];
        this.orderSearch();
      } catch (err) {
        console.log("路由变化时接口报错啦！");
      }
    },
    // 加载
    loadSearchRecords() {
      if (!this.isFinalPage) {
        this.currentPage++;
        if(this.searchRecordsLoading) return;
        this.searchRecordsLoading = true;
        this.orderSearch();
      } else {
        this.searchRecordsLoading = false;
      }
    },
    // 搜索
    async orderSearch() {
      const res = await partnerRfqQuery(this.getParams(this.currentPage));
      if (res.rspResult.bizCode == 200) {
        const _list = res.rspPageData.list || [];
        // this.totalPage=res.rspPageData.totalPage
        this.searchRecordList = this.searchRecordList.concat(_list);
        if(!this.rfqId&&this.searchRecordList.length>0){
          this.rfqId=this.searchRecordList[0].id
          this.$emit('getDetail',this.rfqId)
          this.searchRecordList[0].isRead=1
        }
        if (res.rspPageData.totalPage!=0&&this.currentPage < res.rspPageData.totalPage) {
          this.isFinalPage = false;
        } else {
          this.isFinalPage = true;
          this.searchRecordsLoading = false;
        }
        if(this.searchRecordList.length==0){
          this.$emit('noListData',true)
        }else{
          this.$emit('noListData',false)
        }
        this.active=0
      } else {
        this.$message.error(res.rspResult.message);
      }
    },
    activeItem(item, index) {
      this.active = index;
      item.isRead=1
      this.$emit('getDetail',item.id)
      // this.getRfqDetail(item.id);
    },
  },
  created() {
    // this.orderSearch();
  },
};
</script>
<style lang="scss" scoped>
.isEmergencytag{
  position: absolute;
  width: 52px; /* 根据需要调整 */
  height: 18px; /* 高度设置为0 */
  font-size: 12px;
  font-weight: 700;
  background-color: #FF081F;
  clip-path: polygon(0% 0%, 100% 0%, 100% 10%, 90% 100%, 0% 100%);
  display: flex;
  align-items: center;
  color: #ffffff;
  font-size: 12px;
  top: -4px;
  left: 0px;
  border-radius: 2px 4px 0 0;
  i{
    font-size: 8px;
    margin:0 4px;
  }
}
.records-page-loading{
  text-align: center;
}
.orderList{
  width: 390px;
}
.search-records {
  // overflow-y: auto;
  // height: calc(100vh - 253px);
  // overflow-x: hidden;
}
.listDiv {
  width: 390px;
  margin-bottom: 12px;
  position: relative;
  .itemCard {
    background: #fff;
    border-radius: 4px;
    cursor: pointer;
    border: 2px solid rgba(225,225,225,0.1);
    .iteminfo {
      display: flex;
      padding: 16px 16px 12px 16px;
      .iteminfoLeft {
        .infoTitle {
          display: flex;
          // align-items: center;
          margin-bottom: 8px;
          .name {
            color: #222222;
            font-size: 16px;
            font-weight: 700;
            max-width: 236px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            padding-right: 4px;
            height: 48px;
          }
        }
        .partNum {
          color: #222222;
          font-size: 14px;
          margin-bottom: 8px;
        }
        .infoTag {
          .tagItem {
            margin-right: 8px;
            margin-bottom: 4px;
          }
        }
      }
      .iteminImg{
        width: 80px;
        height: 80px;
        margin-left: auto;
        display: flex;
        border: 1px solid #CFD5DF;
        flex-shrink: 0;
        .partLogo {
          width: 100%;
          object-fit: contain;
        }
      }

    }
    .itemComp {
      background: #f9fcff;
      border-radius: 0px 0px 4px 4px;
      color: #222222;
      font-size: 14px;
      padding: 10px 16px;
      display: flex;
      align-items: center;
      .buyerCompName{
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        flex: 1;
        padding-right: 8px;
      }
      .addres {
        margin-left: auto;
        .iconfont {
          font-size: 14px;
          color: #98a3b7;
          text-align: right;
          margin-right: 5px;
        }
        .flag {
          width: 22px;
          height: 16px;
        }
      }
    }
  }
  .itemCard:hover {
    box-shadow: 0 20px 16px 0 hsla(0, 0%, 70.2%, 0.2);
  }
  .isRead{
    color: #858585 !important;
  }
}
.activeCard {
  border: 2px solid #0863ff !important;
  .name {
    color: #0863ff !important;
  }
}
.contractNamePopover.el-popper.is-dark {
  max-width: 350px;
}
.carbon-img{
  width: 22px;
  height: 22px;
  margin-right: 12px;
  // position: relative;
  // top: -8px;
  // z-index: 1;
}
.channel-data-tag{
  display: flex;
  padding: 1px 8px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  position: absolute;
  left: 0px;
  top: -7px;
  border-radius: 6px 2px 2px 0;
  background: linear-gradient(90deg, #FEF4DB 0%, #FBDCA4 100%);
  .channel-title{
      font-family: "Source Han Sans CN";
      font-size: 10px;
      font-weight: 700;
      line-height: 16px;
      background: linear-gradient(90deg, #E87926 0%, #884603 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
  }
}
</style>
